<form nz-form [formGroup]="leadsService.taskForm" (ngSubmit)="submitForm()">
  <div class="scroll-sidebar" #scroll>
    <nz-collapse nzGhost [nzAccordion]="true">
      <nz-collapse-panel
        nzHeader="Основные параметры"
        [nzActive]="true"
      >
        <div>
          <nz-form-item id="add-task-name">
            <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="name">
              Название
              <i-feather
                nz-tooltip="Используется только для отображения в списке для вашего удобства"
                nzTooltipPlacement="right" nzTooltipColor="#2B85F2" name="helpfull" class="text-primary icon-sm ml-2"
              ></i-feather>
            </nz-form-label>
            <nz-form-control [nzSm]="14" [nzXs]="24">
              <input
                (focusin)="cd.detach()" (focusout)="cd.reattach()"
                nz-input
                placeholder="Название задания"
                formControlName="name"
              />
            </nz-form-control>
          </nz-form-item>

          <nz-form-item id="add-key-words">
            <nz-form-label nzRequired [nzSm]="6" [nzXs]="24" nzFor="key_words">
              Ключевые слова
              <i-feather
                nz-tooltip="Укажите через запятую слова, которые нужно искать в сообщениях."
                nzTooltipPlacement="right" nzTooltipColor="#2B85F2" name="helpfull" class="text-primary icon-sm ml-2"
              ></i-feather>
            </nz-form-label>
            <nz-form-control [nzSm]="14" [nzXs]="24">
              <nz-textarea-count [nzMaxCharacterCount]="10000">
                <textarea (focusin)="cd.detach()" (focusout)="cd.reattach()" rows="4" placeholder="Например: репетитор математики, учитель математики, преподаватель математики"
                          formControlName="key_words" nz-input></textarea>
              </nz-textarea-count>
            </nz-form-control>
          </nz-form-item>

          <nz-form-item id="add-negative-key-words">
            <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="negative_key_words">
              Минус слова
              <i-feather
                nz-tooltip="Укажите через запятую слова или фразы, при наличии которых сообщения будут исключены."
                nzTooltipPlacement="right" nzTooltipColor="#2B85F2" name="helpfull" class="text-primary icon-sm ml-2"
              ></i-feather>
            </nz-form-label>
            <nz-form-control [nzSm]="14" [nzXs]="24">
              <nz-textarea-count [nzMaxCharacterCount]="10000">
                <textarea (focusin)="cd.detach()" (focusout)="cd.reattach()" rows="4" placeholder="Например: работа,школа,крипта"
                          formControlName="negative_key_words" nz-input></textarea>
              </nz-textarea-count>
            </nz-form-control>
          </nz-form-item>

          <nz-form-item class="hidden" id="lead-task-scan">
            <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="all_chats">
              Сканировать все чаты в сервисе
              <i-feather
                nz-tooltip="Будет собирать сообщения со всех чатов что мониторит наш сервис"
                nzTooltipPlacement="right" nzTooltipColor="#2B85F2" name="helpfull" class="text-primary icon-sm ml-2"
              ></i-feather>
            </nz-form-label>
            <nz-form-control [nzSm]="14" [nzXs]="24">
              <label id="all_chats" nz-checkbox formControlName="all_chats">Да</label>
            </nz-form-control>
            <div *ngIf="leadsService.taskForm.value.all_chats" class="text-info"></div>
          </nz-form-item>

          <div formArrayName="chats" id="lead-task-chats" class="multi-field-wrap">
            <nz-form-item *ngFor="let item of getControl('chats')?.controls; trackBy: trackByFn; let i = index">
              <nz-form-label *ngIf="i === 0" [nzSm]="6" [nzXs]="24">
                Чаты для сканирования
                <i-feather
                  nz-tooltip="Ваши чаты для мониторинга сообщений (можно вставлять списком)"
                  nzTooltipPlacement="right" nzTooltipColor="#2B85F2" name="helpfull" class="text-primary icon-sm ml-2"
                ></i-feather>
              </nz-form-label>
              <div *ngIf="i > 0" class="col-12 col-sm-3"></div>
              <nz-form-control
                [nzSm]="14" [nzXs]="24"
                nzErrorTip="Please input passenger's name or delete this field."
              >
                <input
                  nz-input
                  class="passenger-input"
                  placeholder="@teleseller_chat"
                  (paste)="onPaste($event, i, 'chats')"
                  formControlName="{{i}}"
                />
                <i-feather (click)="removeInput(i)" name="minus-circle" class="field-remove-icon icon-md"></i-feather>
              </nz-form-control>
            </nz-form-item>
            <nz-form-item>
              <div class="col-12 col-sm-3"></div>
              <nz-form-control [nzSm]="14" [nzXs]="24" nzErrorTip="Please input your password!">
                <button type="button" nz-button nzType="dashed" class="add-button" (click)="addInput()">
                  <i-feather name="plus-circle" class="mr-2"></i-feather>
                  Добавить чат
                </button>
              </nz-form-control>
            </nz-form-item>
          </div>


          <nz-form-item *ngIf="editLeadTask">
            <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="history_scanned">
              Перезапустить сканирование истории чатов
              <i-feather
                nz-tooltip="Будет произведен скан истории чатов за 14 дней с лимитом в 1000 сообщений на каждый чат"
                nzTooltipPlacement="right" nzTooltipColor="#2B85F2" name="helpfull" class="text-primary icon-sm ml-2"
              ></i-feather>
            </nz-form-label>
            <nz-form-control [nzSm]="14" [nzXs]="24">
              <label id="history_scanned" nz-checkbox formControlName="history_scanned">Да</label>
            </nz-form-control>
          </nz-form-item>
        </div>
      </nz-collapse-panel>

      <nz-collapse-panel nzHeader="Дополнительно ИИ">

        <div formArrayName="text_variations" id="lead-task-texts" class="multi-field-wrap">
          <nz-form-item
            *ngFor="let item of getControl('text_variations')?.controls; trackBy: trackByFn; let i = index">
            <nz-form-label *ngIf="i === 0" [nzSm]="6" [nzXs]="24">
              Примеры объявлений/сообщений
              <i-feather
                nz-tooltip="Важно писать кратно без воды, так, как потенциально напишут люди в сканируемых чатах, сообщения которые вам нужны, для обозначения ключевого слова указывайте знак восклицания перед ним"
                nzTooltipPlacement="right" nzTooltipColor="#2B85F2" name="helpfull" class="text-primary icon-sm ml-2"
              ></i-feather>
            </nz-form-label>
            <div *ngIf="i > 0" class="col-12 col-sm-3"></div>
            <nz-form-control
              [nzSm]="14" [nzXs]="24"
              [nzValidateStatus]="(getControl('text_variations').value[i].length > 100) ? 'warning' : ''"
              nzWarningTip="Текст слишком длинный, лучше писать вкратце без лишних слов, что бы не запутать ИИ."
              nzErrorTip="Please input passenger's name or delete this field."
            >
                  <textarea (paste)="onPaste($event, i, 'text_variations')" (focusin)="cd.detach()"
                            (focusout)="cd.reattach()" autosize nz-input formControlName="{{i}}" class="passenger-input"
                            placeholder="Тут напишите пример сообщений по которому ИИ будет сравнивать входящий поток сообщений из чатов"></textarea>
              <i-feather (click)="removeInput(i, 'text_variations')" name="minus-circle"
                         class="field-remove-icon icon-md"></i-feather>
            </nz-form-control>

          </nz-form-item>
          <nz-form-item>
            <div class="col-12 col-sm-3"></div>
            <nz-form-control [nzSm]="14" [nzXs]="24" nzErrorTip="Please input your password!">
              <button type="button" nz-button nzType="dashed" class="add-button"
                      (click)="addInput('text_variations')">
                <i-feather name="plus-circle" class="mr-2"></i-feather>
                Добавить пример
              </button>
            </nz-form-control>
          </nz-form-item>
        </div>
        <nz-form-item id="lead-task-scope">
          <nz-form-label nzRequired [nzSm]="6" [nzXs]="24" nzFor="min_scope">
            Порог схожести
            <i-feather
              nz-tooltip="Нейросеть сопоставляет сообщения в чатах с вашими примерами ниже и получает процент похожести. При пороге около 50% возможно появление не подходящих лидов, а около 60% – почти точное совпадение, но высокий порог может привести к пропуску возможных лидов."
              nzTooltipPlacement="right" nzTooltipColor="#2B85F2" name="helpfull" class="text-primary icon-sm ml-2"
            ></i-feather>
          </nz-form-label>
          <nz-form-control [nzSm]="14" [nzXs]="24" nzErrorTip="Укажите порог">
            <nz-input-group style="width: min-content;" nzAddOnAfter="%">
              <nz-input-number id="min_scope" formControlName="min_scope" [nzMin]="45" [nzMax]="100"
                               [nzStep]="0.5"></nz-input-number>
            </nz-input-group>
            <nz-alert *ngIf="leadsService.taskForm.get('min_scope').value < 52" class="pt-3" nzType="info"
                      nzMessage="Вы указали низкое значение, если будет поступать слишком много не подходящих лидов, необходимо будет вернуться в редактирование увеличить это значение."
                      nzShowIcon></nz-alert>
          </nz-form-control>
        </nz-form-item>
      </nz-collapse-panel>

      <nz-collapse-panel
        id="lead-task-autoscan"
        nzHeader="Автоматический ответ"
      >
        <app-leads-scan-tasks-automessage></app-leads-scan-tasks-automessage>
      </nz-collapse-panel>
    </nz-collapse>
    <div class="text-center mb-12">
      <button type="button" class="btn btn-link" (click)="startLeadTaskTour()">Виртуальный помощник</button>
    </div>
  </div>
  <div class="modal-footer-panel">
    <nz-form-item class="m-0">
      <nz-form-control>
        <button [nzLoading]="isLoading$ | async" [disabled]="isLoading$ | async" nz-button
                [nzType]="(isLoading$ | async) ? 'default' : 'primary'">
          {{copy ? 'Скопировать' : 'Сохранить'}}
          <i-feather name="save" class="icon-md align-top ml-2"></i-feather>
        </button>
      </nz-form-control>
    </nz-form-item>
  </div>
</form>
